import { shiftEditorViewState } from "..";
import { IBreakEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateBreaksShift", function updateBreaksShift(breaks: IBreakEntity[]) {
    if (shiftEditorViewState().shift) {
        shiftEditorViewState().shift.breaks = breaks;
    }
});